import Vuex from 'vuex';
import Vue from 'vue';
import app from './modules/app';
import nav from './modules/nav';
import giftVouchers from './modules/gift-vouchers';
import supplierPayments from './modules/payments/supplierPayments';
import clientPayments from './modules/payments/clientPayments';
import * as C from './modules/constants';
import supplierPaymentsFilterStorage from '../services/supplier-payments-filter-storage';

Vue.use(Vuex);

/**
 * The supplier payments filters are remembered after every change made to them (not after the
 * filter lists load, which clears the selections, nor after leaving the page), so a reload
 * keeps them.
 */
const SUPPLIER_PAYMENTS_FILTER_CHANGES = [
  C.SUPPLIER_PAYMENTS_FILTER_TYPE_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_ARRIVAL_FROM_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_ARRIVAL_TO_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_PAID_FROM_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_PAID_TO_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_PRODUCTS_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_BRANDS_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_DOMAINS_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_CHANGE,
  C.SUPPLIER_PAYMENTS_FILTER_SUPPLIERS_SEARCH,
  C.SUPPLIER_PAYMENTS_FILTER_HIDE_ZERO_CHANGE,
].map(type => `supplierPayments/${type}`);

const rememberSupplierPaymentsFilters = (store) => {
  store.subscribe((mutation, state) => {
    if (SUPPLIER_PAYMENTS_FILTER_CHANGES.includes(mutation.type)) {
      supplierPaymentsFilterStorage.save(state.supplierPayments.filter);
    }
  });
};

export default new Vuex.Store({
  strict: true,
  modules: {
    app,
    nav,
    giftVouchers,
    supplierPayments,
    clientPayments,
  },
  plugins: [rememberSupplierPaymentsFilters],
});



// WEBPACK FOOTER //
// ./src/store/index.js